// extracted by mini-css-extract-plugin
export default {"desktop":"o8Gcl_","compact":"OTiTim","mobile":"FtLty_"};